<template>
  <div v-if="reservationId" class="qr">
    <vue-qrcode
      :value="reservationId"
      :scale="scale || 6" />
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

export default {
  name: 'ReservationQrcode',
  props: [
    'scale',
    'reservationId' // qrCode의 reservationId는 order_id임(!== order_uuid)
  ],
  components: {
    VueQrcode
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.qr {
  text-align: center;
}
</style>
